import axios from "axios";
export const getAustraliaData = async (query) => {
  try {
    query = query.replaceAll("&", " ");
    const params = {
      name: query,
    };
    const data = await axios.get(
      `${process.env.REACT_APP_COMPANY_LOOKUP_BASE_URL}/searchAustraliaCompany`,
      {
        params,
      }
    );
    const temp = data.data.substring(9);
    let final = temp.split("");
    final.pop();
    final = final.join("");
    final = JSON.parse(final);
    const { Message, Names } = final;
    if (Message) throw new Error(Message, 400);
    let finalData = Names;
    if (finalData === "No Search result found") return [];
    let filter = [];
    for (let item of finalData) {
      const { Abn, Name, NameType, IsCurrent } = item;
      const obj = {
        companyNumber: Abn,
        companyName: Name,
        companyType: NameType,
        companyStatus: IsCurrent ? "ACTIVE" : "NOT-ACTIVE",
      };
      filter.push(obj);
    }
    return filter;
  } catch (error) {
    return error;
  }
};
